enum StarbucksMerchantId {
  Starbucks = 'starbucks-merchant-id',
  Kowalskis = '97035900006',
  VillaGroupJfk = '97400802647',
  HmsHost = '97026601001',
  ChapmanUniversity = '97400705279',
  FloridaStateUniversity = '97400705311',
}

export { StarbucksMerchantId };
